import { SuggestedCompany } from "../../../types/CompanyInfo";
import { Grid, GridItem } from "../../../components-v2/Box";
import { Icon } from "../../../components-v2/Icon";

export function SearchResultTableRow({
  company,
  onSelect,
}: {
  company: SuggestedCompany;
  onSelect: (company: SuggestedCompany) => void;
}) {
  return (
    <>
      <button key={company.organizationnumber} onClick={() => onSelect(company)}>
        <Grid className={"hover:bg-alt2"} alignItems={"center"} borderBottom padding>
          <GridItem xs={11} md={5}>
            {company.name}
          </GridItem>
          <GridItem
            xs={11}
            md={3}
            whitespace={"nowrap"}
            className={"text-ellipsis subtle"}
            textSize={"sm"}
          >
            {company.organizationnumber}
          </GridItem>
          <GridItem
            xs={11}
            md={3}
            whitespace={"nowrap"}
            className={"text-ellipsis subtle"}
            textSize={"sm"}
          >
            {company.city}
          </GridItem>
          <GridItem
            textAlign={"right"}
            className={"xs-only:tw-row-start-1 xs-only:tw-row-span-4 xs-only:tw-col-start-12"}
          >
            {<Icon name={"caret-right"} />}
          </GridItem>
        </Grid>
      </button>
    </>
  );
}
